var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 3.02604V8.53343C18.6667 9.28017 18.6667 9.65353 18.812 9.93875C18.9398 10.1896 19.1438 10.3936 19.3947 10.5214C19.6799 10.6668 20.0533 10.6668 20.8 10.6668H26.3074M21.3333 17.3333H10.6667M21.3333 22.6667H10.6667M13.3333 12H10.6667M18.6667 2.66667H11.7333C9.49312 2.66667 8.37302 2.66667 7.51737 3.10264C6.76472 3.48613 6.1528 4.09806 5.76931 4.8507C5.33333 5.70635 5.33333 6.82646 5.33333 9.06667V22.9333C5.33333 25.1735 5.33333 26.2936 5.76931 27.1493C6.1528 27.9019 6.76472 28.5139 7.51737 28.8974C8.37302 29.3333 9.49312 29.3333 11.7333 29.3333H20.2667C22.5069 29.3333 23.627 29.3333 24.4826 28.8974C25.2353 28.5139 25.8472 27.9019 26.2307 27.1493C26.6667 26.2936 26.6667 25.1735 26.6667 22.9333V10.6667L18.6667 2.66667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile06);
export default __webpack_public_path__ + "static/media/file-06.ae6c4e924c3caa45b3ea9d44c5ed7638.svg";
export { ForwardRef as ReactComponent };